import { call, put, takeLatest } from 'redux-saga/effects';
import { getDiscordUser, getDiscordRole } from '@utils/api/discord';
import { getDiscordLogs, getDiscordLogHistory } from '@utils/api/discord-logs';
import { createFlashMessage } from '@components/Flash/redux';
import { exportDiscordLogsAPI } from '@utils/ajax';
import { startLoading, stopLoading } from './actions';
import { actionTypes } from './action-types';

function* fetchDiscordUser({ payload }) {
  try {
    const { result, success } = yield call(getDiscordUser, payload);

    if (success) {
      yield put({
        type: actionTypes.fetchDiscordUserComplete,
        payload: result.discordUser
      });
    } else {
      yield put({
        type: actionTypes.fetchDiscordUserError
      });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: actionTypes.fetchDiscordUserError });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

function* fetchDiscordLogsSaga({ payload }) {
  try {
    const { result, success } = yield call(getDiscordLogs, payload);

    if (success) {
      yield put({
        type: actionTypes.fetchDiscordLogsComplete,
        payload: result
      });
    } else {
      yield put({
        type: actionTypes.fetchDiscordLogsError
      });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: actionTypes.fetchDiscordLogsError });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Erro ao carregar logs do Discord.',
        variables: { dismissible: true }
      })
    );
  }
}

function* fetchDiscordLogHistorySaga({ payload }) {
  try {
    const { result, success } = yield call(
      getDiscordLogHistory,
      payload.userId
    );

    if (success) {
      yield put({
        type: actionTypes.fetchDiscordLogHistoryComplete,
        payload: result
      });
    } else {
      yield put({
        type: actionTypes.fetchDiscordLogHistoryError
      });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: actionTypes.fetchDiscordLogHistoryError });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Erro ao carregar histórico de logs.',
        variables: { dismissible: true }
      })
    );
  }
}

function* exportDiscordLogsSaga({ payload }) {
  try {
    yield put(startLoading('exportReport'));
    const response = yield call(exportDiscordLogsAPI, payload);

    if (!response.ok) throw new Error('Erro ao exportar planilha');

    const blob = yield response.blob();
    const fileName = `discord-logs-${
      new Date().toISOString().split('T')[0]
    }.csv`;

    const url = window.URL.createObjectURL(blob); // NOSONAR
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url); // NOSONAR

    yield put(stopLoading('exportReport'));
    yield put({
      type: actionTypes.exportDiscordLogsComplete
    });
    yield put(
      createFlashMessage({
        type: 'success',
        message: 'Relatório exportado com sucesso.',
        variables: { dismissible: true }
      })
    );
  } catch (error) {
    console.error(error);
    yield put(stopLoading('exportReport'));
    yield put({ type: actionTypes.exportDiscordLogsError });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Erro ao exportar relatório.',
        variables: { dismissible: true }
      })
    );
  }
}

function* fetchDiscordRoleSaga({ payload }) {
  try {
    const { result, success } = yield call(getDiscordRole, payload);

    if (success) {
      yield put({
        type: actionTypes.fetchDiscordRoleComplete,
        payload: result.role
      });
    } else {
      const msg = result?.message || 'Role não encontrada';
      yield put({
        type: actionTypes.fetchDiscordRoleError,
        payload: msg
      });
      yield put(
        createFlashMessage({
          type: 'danger',
          message: msg,
          variables: { dismissible: true }
        })
      );
    }
  } catch (error) {
    console.error(error);
    yield put({
      type: actionTypes.fetchDiscordRoleError,
      payload: 'Erro ao buscar role do Discord'
    });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Indisponível, tente novamente em alguns minutos.',
        variables: { dismissible: true }
      })
    );
  }
}

export function createDiscordSaga(types) {
  return [
    takeLatest(types.fetchDiscordUser, fetchDiscordUser),
    takeLatest(types.fetchDiscordLogs, fetchDiscordLogsSaga),
    takeLatest(types.fetchDiscordLogHistory, fetchDiscordLogHistorySaga),
    takeLatest(types.exportDiscordLogs, exportDiscordLogsSaga),
    takeLatest(types.fetchDiscordRole, fetchDiscordRoleSaga)
  ];
}
